export const EXPERIMENT_UPSELL_SURVEY = 'upsell_survey';
export const EXPERIMENT_FREE_ACCOUNT = 'free-account-launch';
export const EXPERIMENT_PROGRESS_PANEL_TOOLTIP = 'progress-panel-tooltip';
export const EXPERIMENT_SIGN_IN_PANEL_REDESIGN = 'sign-in-panel-redesign';

export const FF_OUTAGE_BANNER = 'we-transfer-outage-banner';
export const FF_PIXEL_TRACKING = 'marketing-pixel-tracking';
export const FF_IMPLEMENT_SPACES = 'implement-spaces';
export const FF_HEADSPACE_PROMOTION = 'headspace-promotion';
export const FF_STRIPE_SCA_CARD_FLOW = 'stripe-sca-card-flow';
export const FF_SIGNUP_VERIFICATION = 'signup-verification';
